import { ReactNode } from 'react';

import { Skeleton } from '@/components/ui/skeleton';

const SKELETON_COUNT = 3;

const ResourceTileSkeleton = () => (
  <div className="flex w-full items-center gap-4 rounded-lg border border-border bg-background px-4 py-4">
    <Skeleton className="h-12 w-12 shrink-0 rounded" />
    <div className="flex flex-1 flex-col justify-center gap-1">
      <Skeleton className="h-5 w-32" />
      <Skeleton className="h-5 w-48" />
    </div>
    <Skeleton className="size-8 shrink-0 rounded" />
  </div>
);

interface ResourceListProps {
  isLoading: boolean;
  isEmpty: boolean;
  /** Shown when search or filters match nothing. */
  noResultsMessage: string;
  children: ReactNode;
}

/** The tile list on a developer-settings page, with its loading and no-results states. */
export const ResourceList = ({
  isLoading,
  isEmpty,
  noResultsMessage,
  children,
}: ResourceListProps) => {
  if (isLoading) {
    return (
      <div className="flex w-full flex-col items-stretch gap-3 pt-1">
        {Array.from({ length: SKELETON_COUNT }, (_, index) => (
          <ResourceTileSkeleton key={`resource-skeleton-${index}`} />
        ))}
      </div>
    );
  }

  if (isEmpty) {
    return (
      <p className="px-6 py-10 text-center text-sm leading-5 font-medium text-muted-foreground">
        {noResultsMessage}
      </p>
    );
  }

  // pt-1 keeps the first tile's focus ring clear of the sticky toolbar above, as on Rules.
  return <ul className="flex w-full flex-col items-stretch gap-3 pt-1">{children}</ul>;
};
